// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"9f8a315a","652":"68117903","682":"21fdf425"}[chunkId] + ".chunk.js";
};